exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-333c122a] {\n    border-collapse: separate;\n    border-spacing: 10px; /* Adjust the spacing as needed */\n}\ntd[data-v-333c122a] {\n    padding: 10px; /* Adjust the padding as needed */\n}\n", ""]);

// exports
